import skillsImage from "../../libs/skillsImage";

const WorkContent = ({ work }) => {
  return (
    <div
      className="w-full h-full text-[25px] rounded-[50px] text-white bg-[#3E3232] px-12 py-10 flex flex-col"
    > 
      <h2 className="text-3xl font-bold mb-6">{work.name}</h2>
      <p className="max-h-[450px] overflow-y-scroll rounded-2xl p-7 py-4 w-fit h-fit whitespace-pre-line">
        {work.description}
      </p>
    </div>
  );
};

export { WorkContent };
